import React from "react";

import { Button } from "aible";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import Logo from "images/logo1.png";
import ChatAibleLogo from "images/Aible_Logo/chataible.svg";

import styles from "./style.module.css";
import { isEnabled } from "utils/featureFlags";

export default class Registration extends React.Component {
  state = {
    terms: false,
    token: null
  };

  handleRegister() {
    const { handleRegister, handleAzureRegister, token, uiState } = this.props;
    let pass1 = null;
    let pass2 = null;

    if (!isEnabled("chat-aible-consumer")) {
      pass1 = this.refs.password.value;
      pass2 = this.refs.password_two.value;
      if (!pass1) {
        pass1 = null;
      }
      if (!pass2) {
        pass2 = null;
      }
    }

    if (token) {
      return handleAzureRegister(this.refs.fullname.value, this.refs.username.value, this.refs.company.value, token);
    } else {
      return handleRegister(this.refs.fullname.value, this.refs.username.value, pass1, pass2, uiState);
    }
  }

  handleKeyPress(event) {
    const { handleRegister } = this.props;

    if (event.key == "Enter") {
      this.handleRegister();
    }
  }

  componentDidMount() {
    const { fullname, email, token } = this.props;
    if (fullname) {
      this.refs.fullname.value = fullname;
    }
    if (email) {
      this.refs.username.value = email;
    }
    if (token) {
      this.setState({ terms: true });
    }
  }

  render() {
    const { isLoading, error, handleRegister, history, token } = this.props;
    const { terms } = this.state;

    const productName = isEnabled("chat-aible-consumer") ? "ChatAible" : "Aible";

    return (
      <div className={styles.body}>
        <div className={styles.loginBox}>
          <div className={styles.loginHeader}>
            <div className={styles.name}>
              <img className={styles.logoImage} src={isEnabled("chat-aible-consumer") ? ChatAibleLogo : Logo} />
            </div>
          </div>
          <div className={styles.loginContent}>
            <div className={styles.registerTitle}>
              {!token ? "Create your new " + productName + " account" : "Enter information for your Aible Account"}
            </div>
            <div className={styles.inputHolder} style={{ marginTop: "15px" }}>
              <div>{"Full Name:"}</div>
              <input ref="fullname" className={styles.input} />
            </div>
            <div className={styles.inputHolder} style={{ marginTop: "15px" }}>
              <div>{"Email:"}</div>
              <input ref="username" className={styles.input} />
            </div>
            <div className={styles.inputHolder + (!token ? " " + styles.hide : "")} style={{ marginTop: "15px" }}>
              <div>{"Company Name:"}</div>
              <input onKeyPress={(event) => this.handleKeyPress(event)} ref="company" className={styles.input} />
            </div>
            {!isEnabled("chat-aible-consumer") && (
              <React.Fragment>
                <div className={styles.inputHolder + (token ? " " + styles.hide : "")} style={{ marginTop: "15px" }}>
                  <div>{"Password:"}</div>
                  <input
                    ref="password"
                    type={!token ? "password" : "text"}
                    className={styles.input}
                    heap-ignore="true"
                  />
                </div>
                <div className={styles.inputHolder + (token ? " " + styles.hide : "")} style={{ marginTop: "15px" }}>
                  <div>{"Repeat Password:"}</div>
                  <input
                    ref="password_two"
                    type={!token ? "password" : "text"}
                    className={styles.input}
                    onKeyPress={(event) => this.handleKeyPress(event)}
                    heap-ignore="true"
                  />
                </div>
              </React.Fragment>
            )}
            <div className={styles.terms + (token ? " " + styles.hide : "")}>
              <input
                type="checkbox"
                style={{ margin: "2px 8px 2px 0px", cursor: "pointer" }}
                checked={terms}
                onChange={() => {
                  this.setState({ terms: !terms });
                }}
              />
              <div className={styles.tMsg}>
                <span>{"I have read and agree to the"}</span>
                <a href="https://www.aible.com/terms-of-use" rel="noreferrer" target="_blank">
                  {"Terms of Use"}
                </a>
                <span>{"and"}</span>
                <a href="https://www.aible.com/privacy-policy" rel="noreferrer" target="_blank">
                  {"privacy policy"}
                </a>
              </div>
            </div>
            <div className={styles.buttonHolder}>
              <Button
                type="primary"
                onClick={() => this.handleRegister()}
                disabled={isLoading === true || !terms}
                className={styles.button}
              >
                {!token ? "Register" : "Activate your account"}
              </Button>
            </div>
            {!token ? (
              <div className={styles.newUser}>
                <div>
                  {"Already have an account?"}
                  <a onClick={() => history.push("/login")} style={{ marginLeft: "5px" }}>
                    {"Login here"}
                  </a>
                </div>
              </div>
            ) : (
              ""
            )}
            {isLoading === true && <LoadingIndicator />}
            <div className={styles.error}>{error}</div>
          </div>
        </div>
      </div>
    );
  }
}
